module.exports = __webpack_public_path__ + "static/media/smiley-cool.f097ce93.png";